import SVG from "react-inlinesvg";
import { Container } from "./styles";

interface ModalButtonProps {
  onClick: () => void;
  label: string;
  subLabel?: string;
  disabled?: boolean;
  "aria-label": string;

}

const ModalButton: React.FC<ModalButtonProps> = ({ onClick, label, subLabel, disabled, "aria-label": ariaLabel }) => {
  return (
    <Container
      as="button"
      type="button"
      className="use-component-styles"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-haspopup="dialog"
    >
      <div className="labels">
        {!subLabel ? (
          label
        ) : (
          <>
            <div className="action-label">{label}</div>
            <div className="mode-label">{subLabel}</div>
          </>
        )}
      </div>
      <div className="submenu-control">
        <SVG src="/assets/settings_dropdown_icon.svg" aria-hidden="true" />
      </div>
    </Container>
  );
};

export default ModalButton;
